export default __webpack_public_path__ + "static/media/svc.14190490.svg";